var generateStyle = function generateStyle(componentTheme) {
  var metric = {
    flexWrap: 'wrap',
    display: 'flex',
    justifyContent: 'flex-start',
    columnGap: componentTheme.metricsColumnGap,
    rowGap: '1.5rem'
  };
  return {
    heading: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingBottom: componentTheme.headingPadding
    },
    cardWrapper: {
      padding: componentTheme.cardWrapperPadding,
      position: 'relative',
      margin: "".concat(componentTheme.cardTopMargin, " auto ").concat(componentTheme.cardBottomMargin, " auto")
    },
    skeletonCardWrapper: {
      padding: componentTheme.cardWrapperPadding,
      height: '502px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    container: {
      paddingTop: componentTheme.metricGroupPaddingTop
    },
    expandButtonContainer: {
      position: 'absolute',
      right: "calc(".concat(componentTheme.viewPaddingRight, " + ").concat(componentTheme.viewPaddingRightAdjust, ")"),
      top: componentTheme.viewPaddingTop
    },
    metricsWrapper: metric,
    metricGroup: metric
  };
};
export default generateStyle;